export default class Partner {
  constructor(item, lang) {
    this._setId(item);
    this._setImage(item, lang);
    this._setUrl(item);
    this._setDescription(item, lang);
    this._setTitle(item, lang);
  }

  /**
   * set id
   * @param {id} param0
   */
  _setId({ id }) {
    this.id = id;
  }

  /**
   * set url
   * @param {url} param0
   */
  _setUrl({ url }) {
    this.url = url;
  }

  /**
   * set image
   * @param {photoUrl} param0
   */
  _setImage({ photoUrl }) {
    this.image = photoUrl;
  }

  /**
   * set title
   * @param {partner} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "name_" + lang;
    this.title = item[key];
  }

  /**
   * set description
   * @param {partner} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "about_" + lang;
    this.description = item[key];
  }
}
